// extracted by mini-css-extract-plugin
export default {"control":"HVPagination_module-T3FVQVLY_control__IrHQg","dots":"HVPagination_module-T3FVQVLY_dots__Yhdur"};